import type { TypedAction } from "../../../generic/redux/TypedRedux";

import type { ViewPaneLocation } from "./layout-panes/PaneLocations";
import type { PaneName } from "./layout-panes/PaneNames";
import { CLOSE_MAIN_MENU, CLOSE_PANE, OPEN_MAIN_MENU, OPEN_PANE } from "./LayoutActionTypes";

export type OpenMainMenu = TypedAction<typeof OPEN_MAIN_MENU>;
export function openMainMenu(): OpenMainMenu {
	return {
		type: OPEN_MAIN_MENU,
	};
}

export type CloseMainMenu = TypedAction<typeof CLOSE_MAIN_MENU>;
export function closeMainMenu(): CloseMainMenu {
	return {
		type: CLOSE_MAIN_MENU,
	};
}

export interface PaneData {
	name: PaneName;
	location: ViewPaneLocation;
}

export type OpenPane = PaneData & TypedAction<typeof OPEN_PANE>;
export function openPane(data: PaneData): OpenPane {
	return {
		type: OPEN_PANE,
		...data,
	};
}

export type ClosePane = PaneData & TypedAction<typeof CLOSE_PANE>;

export function closePane(data: PaneData): ClosePane {
	return {
		type: CLOSE_PANE,
		...data,
	};
}
